import { FC } from 'react';
import { Box, Circle, Image } from '@chakra-ui/react';
import { PaymentCardType } from '@shinetools/pricing-plan-library';

import SunshineIcon from 'components/_core/SunshineIcon';

import basicCardIcon from '../../../../assets/basicCardIcon.svg';
import businessWorldCardIcon from '../../../../assets/businessWorldCardIcon.svg';
import virtualCardIcon from '../../../../assets/virtualCardIcon.svg';

interface CardsProps {
  count: number;
  type: string;
  unlimited?: boolean;
}

const getCardIcon = (type: string) => {
  if (type === 'virtual') {
    return virtualCardIcon;
  }
  if (type === PaymentCardType.BusinessWorldDebitCard) {
    return businessWorldCardIcon;
  }
  return basicCardIcon;
};

const badgeBaseProps = {
  backgroundColor: 'yellow.600',
  color: 'text-primary',
  fontSize: 'font-15',
  fontWeight: 'weight-700',
  size: '22px',
};

const PaymentCardsIcon: FC<CardsProps> = ({ count, type, unlimited }) => {
  const renderBadge = () => {
    if (unlimited) {
      return <Circle {...badgeBaseProps}>∞</Circle>;
    }

    if (count > 1) {
      return (
        <Circle {...badgeBaseProps} fontSize="font-12">
          {count}
        </Circle>
      );
    }

    if (count === 0) {
      return (
        <Circle {...badgeBaseProps}>
          <SunshineIcon name="plus" size="icon-13" transform="rotate(45deg)" />
        </Circle>
      );
    }

    return null;
  };

  return (
    <Box position="relative">
      <Image src={getCardIcon(type)} />
      <Box bottom={0} position="absolute" right="-5px">
        {renderBadge()}
      </Box>
    </Box>
  );
};

export default PaymentCardsIcon;
